import {Provider} from 'mobx-react';
import {useMemo} from 'react';

import {AsyncPriceCourseCardContext, BrowseCourseBadgesContext} from '@udemy/browse-course';
import {FunnelLogContextProvider} from '@udemy/funnel-tracking';
import {CourseUnitStore} from '@udemy/react-discovery-units';

import {useIsMobileAppView} from 'src/hooks/useIsMobileAppView';

import {CourseUnits, CourseUnitsProps} from './course-units.react-component';

export const CourseUnitsWithProviders = ({
    provider = 'all',
    certificationBundle,
}: CourseUnitsProps) => {
    const courseUnitStore = useMemo(() => {
        const unit = {
            items: [],
            type: 'course_unit',
            remaining_item_count: 1,
        };

        return new CourseUnitStore('featured', unit);
    }, []);

    // Reads display_type directly instead of taking it as a prop from the page — it's sourced
    // from the router (an ambient global), so there's nothing to thread through intermediate
    // components.
    const {isReady, isMobileApp} = useIsMobileAppView();
    const hideForMobileApp = !isReady || isMobileApp;

    // Bail out before mounting CourseUnits (and the network/experiment calls its hooks fire) so
    // the bundle and course carousels never render at all in the native app's webview.
    if (hideForMobileApp) {
        return null;
    }

    return (
        <FunnelLogContextProvider pageType="featured">
            <Provider discoveryUnitsStore={courseUnitStore}>
                <BrowseCourseBadgesContext.Provider
                    value={{browseBadgeHandlerOptions: {numberOfBadgesToShow: 1}}}
                >
                    <AsyncPriceCourseCardContext.Provider
                        value={{useCourseProductCard: true, hideCourseDescription: true}}
                    >
                        <CourseUnits
                            provider={provider}
                            certificationBundle={certificationBundle}
                        />
                    </AsyncPriceCourseCardContext.Provider>
                </BrowseCourseBadgesContext.Provider>
            </Provider>
        </FunnelLogContextProvider>
    );
};
